module.exports = __webpack_public_path__ + "img/banco_nacional.d601ccd.png";